import React from "react";

interface Props {
  className?: string;
  color?: string;
}

const FileIcon: React.FC<Props> = ({className, color}) => (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path
      className={className}
      d="M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6Zm7 7V3.5L18.5 9H13Z"
      fill={color || "#2979FF"}
    />
  </svg>
);

export default FileIcon;
